/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { FlatTaskEvaluationOutputDimensions } from './flatTaskEvaluationOutputDimensions';

/**
 * Essay-style flat dimension evaluation.
 */
export interface FlatTaskEvaluationOutput {
  kind?: 'flat';
  dimensions: FlatTaskEvaluationOutputDimensions;
}
